<div class="PGBookingsCalendar">
    <div class="PGBookingsCalendar-Header">
        <div class="PGBookingsCalendar-Header-Controls border-bottom pb-2 mb-3">
            @if (confirmBooking == null) {
                <div class="PGBookingsCalendar-Header-Controls-Left">
                    <button class="btn btn-link" (click)="goPrevMonth()"><i class="fa-regular fa-chevron-left"></i></button>
                </div>
                <div class="PGBookingsCalendar-Header-Controls-Center">
                    <h4 class="mb-0">{{localizationService.data.monthNames[month]}} {{year}}</h4>
                </div>
                <div class="PGBookingsCalendar-Header-Controls-Right">
                    <button class="btn btn-link" (click)="goNextMonth()"><i class="fa-regular fa-chevron-right"></i></button>
                </div>
            }
            @if (confirmBooking != null) {
                <div class="PGBookingsCalendar-Header-Controls-Left">
                    <button class="btn btn-link" (click)="hideConfirmBooking()"><i class="fa-regular fa-chevron-left"></i></button>
                </div>
                <div class="PGBookingsCalendar-Header-Controls-Center">
                    <h4 class="mb-0">{{confirmBooking.experience.title}} - {{confirmBooking.date | locFormat:'date'}}@if (confirmBooking.time != null) {
                        - {{confirmBooking.time | locFormat:'time'}}
                    }</h4>
                </div>
                <div class="PGBookingsCalendar-Header-Controls-Right">
                </div>
            }
        </div>
    </div>
    @if (confirmBooking == null) {
        <div class="PGBookingsCalendar-Content">
            @if (requestAs == 'supplier' && !cumulative) {
                <div>
                    @for (type of ['supplier/experience','supplier/host','supplier/eatery']; track type) {
                        <button class="btn btn-white {{type == requestType ? 'btn-white-selected' : ''}}" (click)="requestType = type; reset()">
                            <i class="fa-regular {{getRequestTypeIcon(type)}}"></i>
                            <span>{{ 'pg-bookings-calendar.request-' + type | locTranslate}}</span>
                        </button>
                    }
                </div>
            }
            @if (!isLoading) {
                @if (bookingsByDay.length == 0) {
                    <div>
                        <h5 class="text-muted mx-2 my-3">{{ 'pg-bookings-calendar.bookings-none' | locTranslate }}</h5>
                    </div>
                }
                @for (date of bookingsByDay; track date) {
                    @if (date.experiences.length > 0) {
                        <div class="PGBookingsCalendar-Content-Date mb-3">
                            <div class="PGBookingsCalendar-Content-Date-Heading mt-3 pb-2 mb-2 border-bottom">
                                <h5 class="m-0 mx-2">{{date.day}} {{localizationService.data.dayNames[date.weekday]}}</h5>
                            </div>
                            @for (experience of date.experiences; track experience) {
                                <div class="PGBookingsCalendar-Content-Date-Experience">
                                    <div class="PGBookingsCalendar-Content-Date-Experience-Heading mb-2 px-2">
                                        <div>
                                            @if (experience.image != null) {
                                                <div class="PGBookingsCalendar-Content-Date-Experience-Heading-Image border rounded">
                                                    <img src="{{experience.image}}"/>
                                                </div>
                                            }
                                            <div>
                                                <span class="ms-1">{{experience.title}}</span>
                                            </div>
                                        </div>
                                        <div>
                                            @if(!cumulative) {
                                                <button class="btn btn-sm btn-primary py-0 px-1 d-block" (click)="exportBookings(date.day, experience)">
                                                    <i class="fa-regular fa-download"></i><span>{{ 'pg-bookings-calendar.bookings-download' | locTranslate }}</span>
                                                </button>
                                            }
                                        </div>
                                    </div>
                                    @for (slot of experience.slots; track slot) {
                                        <div class="PGBookingsCalendar-Content-Date-Experience-Slot mb-2">
                                            <button class="btn btn-block btn-light" (click)="showConfirmBooking(date.day, experience, slot)">
                                                <app-pg-bookings-slot-summary [slotStart]="slot.start" [slotEnd]="slot.end" [productData]="experience.product" [bookingsData]="slot.bookings"></app-pg-bookings-slot-summary>
                                            </button>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    }
                }
            }
            <app-pg-view-more [hidden]="isLoading || atEnd" (viewMore)="loadMore()"></app-pg-view-more>
            @if (isLoading) {
                <app-pg-loading></app-pg-loading>
            }
        </div>
    }
    @if (confirmBooking != null) {
        <div class="PGBookingsCalendar-Confirm">
            <app-pg-confirm-booking [requestAs]="requestAs" [productId]="confirmBooking.experience.id" [productType]="confirmBooking.experience.type" [productDate]="confirmBooking.date" [productTime]="confirmBooking.time" [cumulative]="cumulative"></app-pg-confirm-booking>
        </div>
    }
</div>